import * as amplify from "../util/amplify.ts";
import * as INR from "../INR.ts";
import * as Html from "../util/Html.ts";
import * as actionMenu from "../widget/action-menu-registry.ts";
import * as modal from "../util/modal.ts";
import * as i18n from "../i18n.ts";
import * as forms from "../util/forms.js";
import * as FwDatas from "../FwDatas.ts";
import * as libLocation from "../lib/location.ts";
import * as FeatureSeen from "../util/FeatureSeen.js";

import ApiServer from "../ApiServer.js";
import {ControllerBook} from "../page/ControllerBook.js";

import {FilerTreeCache} from "../server/objects/FilerBeans.js"
import * as fileViewer from "./fileViewer.js"

import TPL_folder_list from "./folder_list.mustache";
import TPL_folder_content from "./folder_content.mustache";
import Icons from "../svg/Icons.ts";
import {upload} from "./filer_dragdrop.js";




INR.onPage(INR.URL.FILER,function(){
  if(FwDatas.getPermission('filer')!=='OK'){
    libLocation.goTo(INR.URL.ENTER_HOME);
    return;
  }

  //check first onboarding
  if(!FeatureSeen.hasSeen('filer.onboarding')){
    FeatureSeen.markSeen('filer.onboarding');
    modal.ask({
      title:'files.onboarding1.title',
      message:'files.onboarding1.message',
      lottie:"/images/lottie/anim_files_tutorial_top_easy_sharing.json",
      mediaSize:160,
      button:[
        {title:"actions.next",onclick:open2},
        {title:"actions.skip",class:"secondary",action:"modalclose"}
      ]
    })
    function open2(){
      modal.closeModal();
      modal.ask({
        title:'files.onboarding2.title',
        message:'files.onboarding2.message',
        lottie:"/images/lottie/anim_files_tutorial_top_folder_color.json",
        mediaSize:160,
        button:[
          {title:"actions.next",onclick:open3},
          {title:"actions.skip",class:"secondary",action:"modalclose"}
        ]
      })
    }
    function open3(){
      modal.closeModal();
      modal.ask({
        title:'files.onboarding3.title',
        message:'files.onboarding3.message',
        lottie:"/images/lottie/anim_files_tutorial_top_access_control.json",
        mediaSize:160,
        button:[
          {title:"actions.start",action:"modalclose"}
        ]
      })
    }
    
  }
  var CONTROLLER = new ControllerBook($('.pane-left'),TPL_folder_list,$('.pane-main'),TPL_folder_content,undefined,FilerTreeCache,function(rootFolder){
    return rootFolder;
  });
  INR.subscribe("filerNeedRefresh mediaDeleted",()=>CONTROLLER.refresh())
  amplify.publish("handleParam");
});
actionMenu.register({
  foldermenu(){
    const 
      folder = FilerTreeCache.get(this.metaId()),
      buttons = [];
    
    if(folder.parentFolderId!==undefined){
      buttons.push({onclick:'fileupload',svg:Icons.ic_export,i18nkey:'actions.upload'})
    }
    if(folder.rights.canUpdate){
      buttons.push({onclick:'folderedit',svg:Icons.ic_settings,i18nkey:'files.foldersettings'})
    }

    if(folder.parentFolderId===undefined){
      buttons.push({onclick:'foldercreate',svg:Icons.ic_add_folder,i18nkey:'files.createfolder'})
    }
    buttons.push({onclick:'togglemenu',svg:Icons.ic_sort,i18nkey:'catsystem.sort.title',
      submenu:[
        {onclick:'foldersort|alphabetical'            , svg:Icons.ic_arrow_down,i18nkey:'files.settings_sort_option.name_a_to_z',svgend:folder.filerSorting==='alphabetical'?Icons.ic_checkmark:undefined},
        {onclick:'foldersort|alphabeticalReverse'     , svg:Icons.ic_arrow_up,i18nkey:'files.settings_sort_option.name_z_to_a',svgend:folder.filerSorting==='alphabeticalReverse'?Icons.ic_checkmark:undefined},
        {onclick:'foldersort|modificationDateReverse' , svg:Icons.ic_access_time,i18nkey:'files.settings_sort_option.modif_date_new',svgend:folder.filerSorting==='modificationDateReverse'?Icons.ic_checkmark:undefined},
        {onclick:'foldersort|modificationDate'        , svg:Icons.ic_access_time_variant,i18nkey:'files.settings_sort_option.modif_date_old',svgend:folder.filerSorting==='modificationDate'?Icons.ic_checkmark:undefined},
      ]})
    if(folder.parentFolderId){
      buttons.push({onclick:'togglemenu',svg:Icons.ic_list_grid,i18nkey:'files.settings_display_mode.title',
        submenu:[
          {onclick:'folderview|GRID',svg:Icons.ic_list_grid,i18nkey:'files.settings_display_mode.grid',svgend:folder.filerDisplayMode==='GRID'?Icons.ic_checkmark:undefined},
          {onclick:'folderview|LIST',svg:Icons.ic_list_row,i18nkey:'files.settings_display_mode.list',svgend:folder.filerDisplayMode==='LIST'?Icons.ic_checkmark:undefined}
        ]})
    }else{
      buttons.push({onclick:'fileropenfeedback',svg:Icons.ic_comment,i18nkey:'actions.feedback'})
    } 
    if(folder.parentFolderId!==undefined){
      if(folder.rights.canDelete){
        buttons.push({onclick:'folderdelete',svg:Icons.ic_delete,i18nkey:'actions.delete',color:'var(--red)'})
      }else{
        buttons.push({onclick:'notadminmodal',svg:Icons.ic_delete,i18nkey:'actions.delete',color:'var(--red)'})
      }
    }
    buttons.push({svg:Icons.ic_download,onclick:"mediadownload",i18nkey:'actions.download'});
    console.log(folder)
    return {'menu':buttons}
  }
})  
Html.register({
  fileropenfeedback:async function(){
    var TPL_FEEDBACK = await import("../modal/feedbacks.mustache");
    modal.openModal(TPL_FEEDBACK,{description:'feedback.filer',type:"FILER"})
  },
  
  foldersort(value){
    ApiServer.filerputfolder(new ApiServer.types.FolderInputBean({
      filerSorting:value,
      metaId:this.metaId()
    }))
    amplify.publish('filerNeedRefresh');
  },
  folderview(value){
    ApiServer.filerputfolder(new ApiServer.types.FolderInputBean({
      filerDisplayMode:value,
      metaId:this.metaId()
    }))
    amplify.publish('filerNeedRefresh');
  },
  async foldercreate(){
    const 
      TPL = await import('./folder_edit.mustache'),
      theModal = modal.openModal(TPL,{
        parentFolderId:FilerTreeCache.getRoot().metaId,
        authorIsMe:true
      }),
      form = theModal.find('form');
    form.on('submit',function(event){
      event.preventDefault();
      event.stopImmediatePropagation();
      event.stopPropagation();
      if(!forms.validate(form)){
        return false;
      }
      ApiServer.filerputfolder(form,function(folder){
        modal.toastDone('files.toastfoldercreated',folder)
        modal.closeModal();
      },function(err){
        if(err.code==='611'){
          modal.oops(i18n.get('fw2.apierrors.611folder'))
        }else{
          modal.oops('fw2.defaultError')
        }
        
      })
      amplify.publish('filerNeedRefresh');
    })  
  },
  async folderedit(){
    const 
      folder = FilerTreeCache.get(this.metaId()),
      TPL = await import('./folder_edit.mustache'),
      theModal = modal.openModal(TPL,folder),
      form = theModal.find('form');
      
    form.on('submit',function(event){
      event.preventDefault();
      event.stopImmediatePropagation();
      event.stopPropagation();
      if(!forms.validate(form)){
        return false;
      }
      ApiServer.filerputfolder(form,function(updatedFolder){
        modal.toastDone('files.toastfolderupdated',updatedFolder)
        modal.closeModal();
      },modal.oops)
      amplify.publish('filerNeedRefresh');

    })  
  },
  folderdelete(){
    const 
      folder = FilerTreeCache.get(this.metaId());
    modal.confirmDelete('files.confirmdeletefolder',()=>{
      ApiServer.filerdeletefolder(folder.metaId).then(()=>{
        modal.toastDone('files.toastfolderdeleted',folder)
      })
      amplify.publish('filerNeedRefresh');
    })
  },
  
  async filemove(){
    const 
      metaId = this.metaId(),
      file = FilerTreeCache.get(metaId),
      //file = FilerTreeCache.get(metaId),
      parentFolderId = await modal.askAsPromiseTpl(await import('./folderpicker.mustache'),{
        title:"actions.moveto",
        value:file.parentFolderId,
        reject:file.parentFolderId,
        button:FilerTreeCache.getRoot().withTree().folders.map(folder=>{
          return folder.withTree()
        })
      });
      
    if(parentFolderId && parentFolderId!==file.parentFolderId){
      fileViewer.close()
      ApiServer.filerputfile({
        metaId,
        parentFolderId
      }).then(updatedFile=>{
        modal.toastDone('files.toastfilemoved',updatedFile)
      })
      amplify.publish('filerNeedRefresh');
    }
  },
  
  async fileedit(){
    const 
      file = FilerTreeCache.get(this.metaId()),
      dotIdx = file.name.lastIndexOf('.'),
      name = (dotIdx===-1)?file.name:file.name.substring(0,dotIdx),
      extension = (dotIdx===-1)?'':file.name.substring(dotIdx),
      TPL = await import('./file_edit.mustache'),
      theModal = modal.openModal(TPL,{metaId:file.metaId,name,extension}),
      form = theModal.find('form');
      
    form.on('submit',function(event){
      event.preventDefault();
      event.stopImmediatePropagation();
      event.stopPropagation();
      if(!forms.validate(form)){
        return false;
      }
      fileViewer.close()
      ApiServer.filerputfile({
        metaId:file.metaId,
        name:form.get(0).name.value+extension
      },function(updatedFile){
        modal.toastDone('files.toastfileupdated',updatedFile)
        modal.closeModal();
      })
      amplify.publish('filerNeedRefresh');

    })  
  },
  
  async fileduplicate(){
    const 
      metaId = this.metaId(),
      file = FilerTreeCache.get(metaId),
      //file = FilerTreeCache.get(metaId),
      parentFolderId = await modal.askAsPromiseTpl(await import('./folderpicker.mustache'),{
        title:"actions.copyto",
        value:file.parentFolderId,
        button:FilerTreeCache.getRoot().withTree().folders.map(folder=>{
          return folder.withTree()
        })
      });
      
    if(parentFolderId){
      ApiServer.filerputfile({
        parentFolderId,
        file:file.pictureUrl,
        name:file.name
      }).then(()=>{
        modal.toastDone('files.toastfileduplicated',file)
      })
      amplify.publish('filerNeedRefresh');
    }
  },
  fileupload(){
    $('.pane-main .fab icon').trigger('click')
  }
  
})

ApiServer["custom.filerupload"] = function(form){
  var 
    parentFolderId = $(form).metaId(),
    files = $(form).find('[data-widget="widget/form/input-images"]').get(0).customFiles.concat([]);
  
  if(files.length===0){
    modal.alert('multiupload.needfile');
    return;
  }else{
    upload(parentFolderId,files)
  }
}
